export const text = {
  productCreated: 'Se ha creado el producto.',
  productError: 'Ha ocurrido un error el cargar tu producto'
};
